import { render, staticRenderFns } from "./payrollDashboard.vue?vue&type=template&id=185d8fa4&scoped=true&"
import script from "./payrollDashboard.vue?vue&type=script&lang=js&"
export * from "./payrollDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185d8fa4",
  null
  
)

export default component.exports